/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import type { QuoteInfo } from "@farmlands/farmlandspro-api";

import { farmlandsProApi } from "../../../services/farmlandspro-api";

export const fetchQuotes = async (accountNumber: string, status: string): Promise<QuoteInfo[]> => {
  const response = await farmlandsProApi.quotes.getQuotes({ accountNumber, status });
  return response.data.quotes ?? [];
};
